import { hot } from 'react-hot-loader';

import { experimentRootUrl } from '../../../urls';

const FiscalYearExperimentList = ({ experiments }) => {
  let title = null;
  const li_list = experiments.sort((a, b) => a.experiment_number < b.experiment_number ? 1 : a.experiment_number > b.experiment_number ? -1 : 0).map((experiment) => {
    if (experiment.experiment_number) {
      title = experiment.experiment_number.toString() + ' - ' + experiment.caption;
    } else {
      title = experiment.caption;
    }
    const thumbnailUrl = "/api/asebi/experiments/" + experiment.id.toString() + "/thumbnail.jpg";
    // const thumbnailUrl = '/api/asebi/experiments/' + experiment.id.toString() + '/' + experiment.img_src;
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '1rem' }}>
        <a href={experimentRootUrl(experiment.fiscal_year, experiment.id)} className="list-group-item list-group-item-action list-group-item-success" style={{ minHeight: '5.8em' }}>
          {title}
        </a>
        <div style={{ marginTop: '0.5rem' }}>
          <figure><img src={thumbnailUrl} className='thumbnail' alt="No Thumbnail" width='300px' /></figure>
        </div>
      </div>
    );
  });

  return (
    <ul className="list-group">
      <div className='experimentList' style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
        {li_list}
      </div>
    </ul>
  );
};

export default hot(module)(FiscalYearExperimentList);
